import CustomerSearchService from '@/services/customerSearch.service'
// import { UserService, AuthenticationError } from '@/services/user.service'
import { TokenService } from '@/services/storage.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    async getFacilityByKeyWord({commit}, {keyword}) {
        try {
            // console.log(keyword)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const customers = await CustomerSearchService.getCustomerByKeyWord(keyword);
            commit('setLoading', false, { root: true })            


            return customers
        } catch (e) {
            // console.log(e)
            return e
        }
    },
    async getFacilityDataById({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await CustomerSearchService.getFacilityDataById(payload)
            commit('setLoading', false, { root: true })            

            return result
        } catch (e) {

        }
    }
}

const mutations = {
}

export const customerSearch = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}